import { ProfileColor } from "../../../ProfileColor";
import { Checkbox, DataSource, DateRangeFilter, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomerServiceProfile extends Layout {
    checkboxExcludeApptStatus: Checkbox;
    checkboxExcludeAuthStatus: Checkbox;
    checkboxExcludeBrokerageStatus: Checkbox;
    checkboxExcludeCommodity: Checkbox;
    checkboxExcludeCustomer: Checkbox;
    checkboxExcludeEntryUser: Checkbox;
    checkboxExcludeInbound: Checkbox;
    checkboxExcludeMoveStatus: Checkbox;
    checkboxExcludeMoveType: Checkbox;
    checkboxExcludeOperationsUser: Checkbox;
    checkboxExcludeOrderStatus: Checkbox;
    checkboxExcludeOrderType: Checkbox;
    checkboxExcludeOsdStatus: Checkbox;
    checkboxExcludeOutbound: Checkbox;
    checkboxExcludeRevenueCode: Checkbox;
    dateRangeFilter: DateRangeFilter;
    layoutColorPicker: ProfileColor;
    panelHierarchyLevel: Panel;
    panelLeftSide: Panel;
    panelRightSide: Panel;
    sourceCsmProfile: DataSource;
    switchIncludeOnlyLateOrders: Switch;
    switchIncludeOnlyMissingAppointments: Switch;
    switchIncludeOnlyServiceIncidents: Switch;
    switchIncludePartialShipments: Switch;
    switchIncludePreassignedOrders: Switch;
    switchIncludeSpotOrders: Switch;
    switchOnHold: Switch;
    switchReadyToBillOrders: Switch;
    textboxAppointmentStatus: Textbox;
    textboxAuthStatus: Textbox;
    textboxBrokerageStatus: Textbox;
    textboxCommodity: Textbox;
    textboxDescr: Textbox;
    textboxEntryUser: Textbox;
    textboxId: Textbox;
    textboxMoveStatus: Textbox;
    textboxMoveType: Textbox;
    textboxOperationsUser: Textbox;
    textboxOrderCustomers: Textbox;
    textboxOrderIbList: Textbox;
    textboxOrderIbType: Textbox;
    textboxOrderObList: Textbox;
    textboxOrderObType: Textbox;
    textboxOrderResponsibilityLevel: Textbox;
    textboxOrderStatus: Textbox;
    textboxOrderTypeId: Textbox;
    textboxOsdStatus: Textbox;
    textboxResponsibilityCodes: Textbox;
    textboxRevenueCode: Textbox;
}
